<span *ngIf="(averageRate ?? 0)>0" class="badge badge-pill rating-badge m-0 rounded-2 p-1"
 [ngClass]="{
        'font-big': big && !small,
        'font-small': small,
        'default-size': !big && !small
      }">
  <p class="m-0">{{ (averageRate | number:'1.0-1')}}</p>
</span>